import { Injectable, inject } from '@angular/core';
import { ConfigurationService } from '@pflegix/config';
import { HttpClientService } from '@pflegix/http-client';
import { BusinessPartnerResponseDto, UpdateBusinessPartnerNotesDto } from '@pflegix/types';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotesFormApi {
  private readonly httpClient = inject(HttpClientService);
  private readonly config = inject(ConfigurationService);

  public updateNotes(
    businessPartnerId: string,
    notes: UpdateBusinessPartnerNotesDto
  ): Observable<BusinessPartnerResponseDto> {
    return this.httpClient.patch<BusinessPartnerResponseDto>(`${this.apiUrl}/${businessPartnerId}/notes`, notes);
  }

  private get apiUrl(): string {
    return `${this.config.get('basePflegixApiUrl')}/api/business-partners`;
  }
}
